import { FieldRegulationSaveRequestDTO } from 'submodules/nerit-aquatec-sdk/services/regulation/dtos/requests/FieldRegulationSaveRequestDTO'
import { FieldRegulationResponseDTO } from 'submodules/nerit-aquatec-sdk/services/regulation/dtos/responses/FieldRegulationResponseDTO'
import { ConditionRowTP, RegulationConditionUtils } from 'modules/fields/utils/RegulationConditionUtils'
import { FieldRegulationFormModel } from 'modules/fields/components/modals/modal-field-regulation/inner/FieldRegulationFormModel'

/** Estado da formatação condicional no modal (fora do form state manager, por ser uma lista). */
export type ConditionalStateTP = {
    isConditional: boolean
    referenceFieldCode?: number
    rows: ConditionRowTP[]
}

export const REQUIRED_FIELD_MESSAGE = 'Campo obrigatório!'

/**
 * Regras do modal de norma por parâmetro: estado inicial, alternância entre fixo e condicional e montagem do DTO.
 */
export class FieldRegulationModalUtils {

    /** Edição de norma condicional abre com a seção visível e as faixas na ordem salva. */
    static initialConditionalState(fieldRegulation?: FieldRegulationResponseDTO): ConditionalStateTP {

        if (!fieldRegulation?.conditions?.length)
            return { isConditional: false, rows: [] }

        return {
            isConditional: true,
            referenceFieldCode: fieldRegulation.referenceField?.code,
            rows: RegulationConditionUtils.fromConditions(fieldRegulation.conditions),
        }
    }

    /** Ativar começa com uma linha vazia; desativar descarta referência e faixas. */
    static toggle(state: ConditionalStateTP): ConditionalStateTP {
        return state.isConditional
            ? { isConditional: false, rows: [] }
            : { isConditional: true, rows: [RegulationConditionUtils.emptyRow()] }
    }

    static linkText(state: ConditionalStateTP): string {
        return state.isConditional ? 'Remover formatação condicional' : 'Formatação Condicional'
    }

    /** Referência escolhida e ao menos uma linha, todas completas. */
    static isConditionalComplete(state: ConditionalStateTP): boolean {
        return !!state.referenceFieldCode && !!state.rows.length && state.rows.every(RegulationConditionUtils.isRowComplete)
    }

    /** Norma fixa manda mínimo/máximo; condicional manda referência e faixas, nunca os dois. */
    static toSaveDTO(formValues: FieldRegulationFormModel, state: ConditionalStateTP): FieldRegulationSaveRequestDTO {

        const dto: FieldRegulationSaveRequestDTO = {
            regulationCode: formValues.regulationCode,
            fieldCode: formValues.fieldCode,
            nature: formValues.nature,
        }

        if (!state.isConditional)
            return { ...dto, minPermitted: formValues.minPermitted, maxPermitted: formValues.maxPermitted }

        return {
            ...dto,
            referenceFieldCode: state.referenceFieldCode,
            conditions: RegulationConditionUtils.toConditions(state.rows),
        }
    }

    static addRow(state: ConditionalStateTP): ConditionalStateTP {
        return { ...state, rows: [...state.rows, RegulationConditionUtils.emptyRow()] }
    }

    static removeRow(state: ConditionalStateTP, index: number): ConditionalStateTP {
        return { ...state, rows: state.rows.filter((row, rowIndex) => rowIndex !== index) }
    }

    static updateRow(state: ConditionalStateTP, index: number, changes: Partial<ConditionRowTP>): ConditionalStateTP {
        return { ...state, rows: state.rows.map((row, rowIndex) => rowIndex === index ? { ...row, ...changes } : row) }
    }
}
